import {PayloadAction} from '@reduxjs/toolkit';
import * as Constants from './constants';
import {call, takeEvery} from '@redux-saga/core/effects';
import {GraphQLRequest, APIRequest, getCookie} from '../../../../utils';
import {
  INetworkRequestObject,
  INetworkResponse,
  INetworkErrorResponse,
  INetworkApiRequestObject,
  INetworkAPIResponse,
} from '../../../../model/Network';
import {APIEndPoint, getAPIEndPoint} from '../../../../config/AppConfig';
import Strings from 'components/Strings';

export function* networkGraphQLSaga({
  payload: {requestData},
}: PayloadAction<INetworkRequestObject>) {
  try {
    const response: INetworkResponse<any> = yield call(
      GraphQLRequest.request,
      requestData,
    );
    if (response && response.data) {
      yield call(requestData.successCb, response);
    } else {
      yield call(requestData.errorCb, {errors: 'Something went wrong!!!'});
    }
  } catch (error: unknown) {
    const networkError = error as INetworkErrorResponse<any>;
    if (networkError && Array.isArray(networkError.errors)) {
      yield call(requestData.errorCb, networkError);
    }
  }
}

export function* networkApiSaga({
  payload: {key, requestData},
}: PayloadAction<INetworkApiRequestObject>) {
  const accessToken: string | null = getCookie('token');

  if (!requestData.url && APIEndPoint[key]) {
    requestData.url = getAPIEndPoint(key);
  }
  if (accessToken && !requestData.disableHeaders) {
    requestData.headers = {
      ...requestData.headers,
      Authorization: `Bearer ${accessToken}`,
      'x-user-id': JSON.parse(localStorage.getItem('userDetails') || '{}')
        ?.cust_id,
    };
  }
  const response: INetworkAPIResponse<any> = yield call(
    APIRequest.request,
    requestData,
  );

  // Handle API response
  if (response.status >= 200 && response.status < 300) {
    // Success: Invoke the success callback
    yield call(requestData.successCb, response);
  } else if (response.status === 401) {
    localStorage.removeItem(Strings.USER_DETAILS);
    document.cookie = 'token=; Max-Age=0; path=/;';
    window.location.replace('/login');
  } else {
    // Error: Invoke the error callback
    yield call(requestData.errorCb, response);
  }
}

export default function* watchAppDetailSaga() {
  yield takeEvery(Constants.NETWORK_REQUEST, networkGraphQLSaga);
  yield takeEvery(Constants.NETWORK_API_REQUEST, networkApiSaga);
}
